<div class="layout-container">
  <p-toolbar>
    <div class="p-toolbar-group-start">
      <div class="logo-section" routerLink="/dashboard">
        <img src="assets/logo.png" alt="Knowzilla" height="42" />
        <span class="logo-text">Backoffice</span>
      </div>
    </div>

    <div class="p-toolbar-group-end">
      <div class="global-search-wrapper">
        <p-autoComplete
          [(ngModel)]="selectedResult"
          [suggestions]="searchGroups()"
          (completeMethod)="onSearch($event)"
          (onSelect)="onResultSelected($event)"
          field="label"
          optionGroupLabel="label"
          optionGroupChildren="items"
          [group]="true"
          [dropdown]="false"
          placeholder="Search companies, users, sessions..."
          inputStyleClass="global-search-input"
        >
          <ng-template pTemplate="group" let-group>
            <span class="search-group-label">{{ group.label }}</span>
          </ng-template>
          <ng-template pTemplate="item" let-item>
            <div class="flex flex-column">
              <span class="font-medium">{{ item.label }}</span>
              @if (item.sublabel) {
                <span class="text-xs text-500">{{ item.sublabel }}</span>
              }
            </div>
          </ng-template>
        </p-autoComplete>
      </div>
      <p-button
        [icon]="themeService.theme() === 'light' ? 'pi pi-moon' : 'pi pi-sun'"
        (click)="toggleTheme()"
        styleClass="p-button-secondary p-button-text theme-switcher-btn"
      />
      <p-button
        label="Logout"
        icon="pi pi-sign-out"
        (click)="authService.logout()"
        [text]="true"
        styleClass="logout-btn desktop-only"
      />
      <!-- Mobile hamburger menu button -->
      <p-button
        icon="pi pi-bars"
        (click)="toggleMobileMenu()"
        [text]="true"
        styleClass="mobile-menu-btn"
      />
    </div>
  </p-toolbar>

  <!-- Mobile Drawer Menu -->
  <p-drawer [(visible)]="mobileMenuOpen" position="right" styleClass="mobile-drawer" header="Menu">
    <nav class="side-nav">
      @for (group of navGroups; track group.label) {
        <div class="nav-group-label">{{ group.label }}</div>
        @for (item of group.items; track item.path) {
          <a
            [routerLink]="item.path"
            routerLinkActive="active-nav-item"
            (click)="closeMobileMenu()"
            class="nav-item"
          >
            <i [class]="item.icon" aria-hidden="true"></i>
            <span>{{ item.label }}</span>
          </a>
        }
      }

      <div class="nav-divider"></div>

      <a
        (click)="logout()"
        (keydown.enter)="logout()"
        tabindex="0"
        role="button"
        class="nav-item logout-item"
      >
        <i class="pi pi-sign-out"></i>
        <span>Logout</span>
      </a>
    </nav>
  </p-drawer>

  <div class="layout-body">
    <aside class="sidebar desktop-only-block" aria-label="Main navigation">
      <nav class="side-nav">
        @for (group of navGroups; track group.label) {
          <div class="nav-group-label">{{ group.label }}</div>
          @for (item of group.items; track item.path) {
            <a [routerLink]="item.path" routerLinkActive="active-nav-item" class="nav-item">
              <i [class]="item.icon" aria-hidden="true"></i>
              <span>{{ item.label }}</span>
            </a>
          }
        }
      </nav>
    </aside>

    <main class="layout-content">
      <router-outlet />
    </main>
  </div>
</div>
